(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("gje-fetch"));
	else if(typeof define === 'function' && define.amd)
		define(["gje-fetch"], factory);
	else if(typeof exports === 'object')
		exports["gje-client-identification"] = factory(require("gje-fetch"));
	else
		root["gje-client-identification"] = factory(root["gje-fetch"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _gjeFetch = __webpack_require__(1);
	
	var _gjeFetch2 = _interopRequireDefault(_gjeFetch);
	
	var _clientIdentificationInterceptor = __webpack_require__(2);
	
	var _clientIdentificationInterceptor2 = _interopRequireDefault(_clientIdentificationInterceptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    configure: function configure(_ref) {
	        var applicationId = _ref.applicationId;
	        var clientName = _ref.clientName;
	        var clientVersion = _ref.clientVersion;
	
	        _gjeFetch2.default.addRequestInterceptors((0, _clientIdentificationInterceptor2.default)({
	            applicationId: applicationId,
	            clientName: clientName,
	            clientVersion: clientVersion
	        }));
	    }
	};

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _hashGenerator = __webpack_require__(3);
	
	var _hashGenerator2 = _interopRequireDefault(_hashGenerator);
	
	var _location = __webpack_require__(4);
	
	var _location2 = _interopRequireDefault(_location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var applicationId = _ref.applicationId;
	    var clientName = _ref.clientName;
	    var clientVersion = _ref.clientVersion;
	    var _ref$location = _ref.location;
	    var location = _ref$location === undefined ? _location2.default.pathname() : _ref$location;
	
	    var sessionId = (0, _hashGenerator2.default)();
	
	    return function (options) {
	        return {
	            headers: Object.assign({}, options.headers || {}, {
	                'Applikasjon': applicationId,
	                'X-Client-SessionId': sessionId,
	                'X-Client-RequestId': (0, _hashGenerator2.default)(),
	                'X-Client-Location': _location2.default.short(location),
	                'X-Client-Name': clientName,
	                'X-Client-Version': clientVersion
	            })
	        };
	    };
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return Math.floor((1 + Math.random()) * 0x1000000).toString(16);
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    pathname: function pathname() {
	        return window.location.pathname;
	    },
	    short: function short(pathname) {
	        var trailingSlash = /\/$/;
	        return (pathname || this.pathname()).replace(trailingSlash, '').split('/').map(function (segment, index, array) {
	            var length = void 0;
	            var isLastSegment = index === array.length - 1;
	            if (!isLastSegment) {
	                length = segment.length;
	                return segment.substring(0, Math.min(length, 3));
	            } else {
	                return segment;
	            }
	        }).join('/');
	    }
	};

/***/ }
/******/ ])
});
;
//# sourceMappingURL=gje-client-identification.js.map